import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { IntlProvider } from 'react-intl';

import { IntlContext, useIntlContext } from '../translation';

export const TranslationProvider = ({ children }) => {
  const intlContextValue = useIntlContext();

  const { locale } = useSelector(state => ({
    locale: state.appSettings?.locale || intlContextValue.defaultLocale
  }), shallowEqual);

  return (
    <IntlContext.Provider value={intlContextValue}>
      <IntlProvider
        locale={locale.replace('_', '-')}
        defaultLocale={intlContextValue.defaultLocale}
        messages={intlContextValue.messages[locale]}
      >
        {children}
      </IntlProvider>
    </IntlContext.Provider>
  );
};
